/**
 * Regex to check dutch phone numbers against
 * @type {RegExp}
 */
const phoneRegex = /^\s*\+?\s*([0-9][\s-]*){9,20}$/

export default phoneRegex
